module.exports = __webpack_public_path__ + "static/thiru-03cc46b59c639b93ef875f35af21d4e3.jpg";